import { STRAPI_API_URL } from '../constants/config'

export const removeScheme = (url: string) => url.replace(/(^\w+:|^)\/\//, '')

// In React Native `new URL()` adds a trailing slash to the URL which needs to be removed, otherwise images don't load.
function removeTrailingSlash(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url
}

/**
 * For images coming from the admin (Strapi) media library.
 * In development, Strapi images come from the local /public/uploads folder, whereas
 * in production they come from AWS S3.
 * @param imageUrl the value of `data.attributes.url` of an image field of a Strapi
 *  REST API response object.
 */
export function makeStrapiImageUrl(imageUrl: string) {
  const url = `${new URL(imageUrl, STRAPI_API_URL)}`
  return removeTrailingSlash(url)
}
